import ViewerWrapperLoader from "./ViewerWrapperLoader";

export default ViewerWrapperLoader;